/**
 * FIGS-style color swatches on product cards
 * Swaps product card image and updates color name on swatch click
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.card-swatches').forEach(function (swatchContainer) {
    var swatches = swatchContainer.querySelectorAll('.card-swatches__swatch');
    var colorNameEl = swatchContainer.querySelector('.card-swatches__color-name');
    var cardWrapper = swatchContainer.closest('.card-wrapper');
    if (!cardWrapper) return;

    var mainImg = cardWrapper.querySelector('.card__media .media img:first-child');

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Update active state
        swatches.forEach(function (s) { s.classList.remove('card-swatches__swatch--active'); });
        swatch.classList.add('card-swatches__swatch--active');

        // Update color name
        var colorName = swatch.getAttribute('data-color-name');
        if (colorNameEl && colorName) {
          colorNameEl.textContent = colorName;
        }

        // Swap main image
        var newSrc = swatch.getAttribute('data-image-url');
        var newSrcset = swatch.getAttribute('data-image-srcset');
        if (mainImg && newSrc) {
          mainImg.src = newSrc;
          if (newSrcset) {
            mainImg.srcset = newSrcset;
          }
        }

        // Update product link to include variant
        var variantId = swatch.getAttribute('data-variant-id');
        if (variantId) {
          var links = cardWrapper.querySelectorAll('a[href]');
          links.forEach(function (link) {
            var href = link.getAttribute('href');
            if (href && href.indexOf('/products/') !== -1) {
              // Remove existing variant param
              var baseUrl = href.split('?')[0];
              link.setAttribute('href', baseUrl + '?variant=' + variantId);
            }
          });
        }
      });
    });
  });
});
